import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, tipo_seguro_social } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const TipoSeguroSocial = ({ id, permisos }) => {
    const [ tiposSeguroSocial, setTiposSeguroSocial ] = useState( null );
    useEffect(() => {
        axiosTiposSeguroSocial();
    }, []);

    const axiosTiposSeguroSocial = () => {
        axios.get( `${servicios_grupogack_catalogo}/tiposegsoc/`, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:
                        setTiposSeguroSocial( respuesta.data.dataResponse );
                        break;
                    case 404:
                        setTiposSeguroSocial([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    return (
        <div id={ id }>
            { tiposSeguroSocial ?
                <DataTableService id={id} title={ tipo_seguro_social } permisos={permisos}
                    columns={[
                        { field: "segSocClave", title: "Clave" },
                        { field: "segSocNom", title: "Nombre" },
                    ]}
                    data={ tiposSeguroSocial } /> : <SpinnerOval />
            }
        </div>
    );
};

export default TipoSeguroSocial;